import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const clampPercentage = (value: number | string | null | undefined) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return 0;
  }

  return Math.max(0, Math.min(100, numericValue));
};

export const getRatioPercentage = (
  value: number | string | null | undefined,
  total: number | string | null | undefined,
) => {
  const numericValue = Number(value);
  const numericTotal = Number(total);

  if (
    !Number.isFinite(numericValue) ||
    !Number.isFinite(numericTotal) ||
    numericValue <= 0 ||
    numericTotal <= 0
  ) {
    return 0;
  }

  return clampPercentage((numericValue / numericTotal) * 100);
};

export const getRelativePercentage = (
  value: number | string | null | undefined,
  maxValue: number | string | null | undefined,
) => {
  const numericValue = Number(value);
  const numericMaxValue = Number(maxValue);

  if (
    !Number.isFinite(numericValue) ||
    !Number.isFinite(numericMaxValue) ||
    numericValue <= 0 ||
    numericMaxValue <= 0
  ) {
    return 0;
  }

  return clampPercentage((numericValue / numericMaxValue) * 100);
};
